import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import * as math from '_core/utils/math';

import Row from './Row';


export default React.memo((props) => {
  const {
    classes,
    
    limit,
    parent,
    getRows,
    getHits,
    isRowExpanded
  } = props;
  
  
  const rows = getRows(parent, isRowExpanded);
  
  if (!rows || rows.isLoading) {
    if (!isRowExpanded)
      return null;
    
    const hits = getHits(parent);
    
    return Array(Math.min(hits, limit)).fill(null).map(() => (
      <Row
        {...props}
        
        rowData={null}
      />
    ));
  }
  
  return (
    <>
      {rows.list.map((item, index) => (
        <Row
          {...props}
          
          key={index}
          rowData={item}
        />
      ))}
      
      {rows.hasNextBar ? (
        <div className={classes.childrenMore}>
          <Button
            variant="text"
            startIcon={<AddIcon />}
            disabled={!rows.hasNext}
            onClick={rows.next}
          >
            Раскрыть
          </Button>
          
          {/*<Button
            variant="text"
            startIcon={<RemoveIcon />}
            disabled={!rows.hasPrev}
            onClick={rows.prev}
          >
            Скрыть
          </Button>*/}
        </div>
      ) : null}
    </>
  );
});
